import script from "./PendingDosesButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingDosesButton.vue?vue&type=script&setup=true&lang=js"

import "./PendingDosesButton.vue?vue&type=style&index=0&id=4a81a6fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a81a6fb"]])

export default __exports__